module.exports = __webpack_public_path__ + "static/media/chevron-square-up.73eb28e4.svg";